import { Component, Input } from '@angular/core';

@Component({
  selector: 'fcp-counter',
  template: '{{ counter }} {{ scale }}',
  styleUrls: []
})
export class CounterComponent {

  @Input() public limit: number;
  @Input() public scale: string;
  public counter = 0;
  private intervalSetting = null;

  constructor() {
    this.getAnimation();
  }

  public getAnimation() {
    this.intervalSetting = setInterval(() => {
      this.count(this.limit);
    }, 5);
  }

  private count(limit: number): void {
    if (this.counter < limit) {
      this.counter++;
    } else {
      this.stopPropagation();
    }
  }

  private stopPropagation(): void {
    clearInterval(this.intervalSetting);
  }

}
